if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        
        this.slideshow = this.querySelector('slideshow-component:not(.slider--collapse)');
        this.thumbnailGallery = this.querySelector('thumbnail-gallery');
        this.activeMedia = this.dataset.activeMedia;

        if (this.slideshow && this.activeMedia) {
          const mediaSlide = this.querySelector(`[data-media-id="${this.activeMedia}"]`);
          setTimeout(() => this.slideshow.jumpToSlide(mediaSlide, true), 0);
        }

        document.addEventListener('variant:change', (event) => {
          if (event.detail.sectionId === this.dataset.section) {
            if (event.detail.variant.featured_media) {
              this.changeImage(event.detail.variant.featured_media.id);
            }
          }
        });

        // ClassyTea: Mutual sticky columns
        this.initStickyBehavior();
      }

      initStickyBehavior() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setupSticky());
        } else {
          setTimeout(() => this.setupSticky(), 200);
        }
      }

      setupSticky() {
        this.gallery = this.closest('.pdp__media');
        this.infoPanel = document.querySelector('.pdp__content');
        
        if (!this.gallery) this.gallery = this;
        if (!this.infoPanel) return;

        this.resizeTimeout = null;
        this.observer = new ResizeObserver(() => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => this.calculateMutualSticky(), 100);
        });

        this.observer.observe(document.documentElement);
        this.observer.observe(this.infoPanel);
        if (this.gallery !== this) {
          this.observer.observe(this.gallery);
        }
        
        this.calculateMutualSticky();
        
        window.addEventListener('resize', () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => this.calculateMutualSticky(), 100);
        });
      }

      getContentHeight(element) {
        if (element.classList.contains('pdp__media')) {
          const mediaGallery = element.querySelector('media-gallery');
          if (mediaGallery) {
            const slides = mediaGallery.querySelectorAll('.slideshow__slide');
            if (slides.length > 0) {
              let totalHeight = 0;
              slides.forEach(slide => {
                totalHeight += slide.offsetHeight;
              });
              return totalHeight;
            }
          }
        }
        
        if (element.classList.contains('pdp__content')) {
          const wrapper = element.querySelector('.pdp__content-wrapper');
          if (wrapper) {
            return wrapper.scrollHeight;
          }
        }
        
        return element.scrollHeight;
      }

      calculateMutualSticky() {
        if (!this.gallery || !this.infoPanel) return;

        this.resetStickyStyles();

        // Only apply on desktop (1024px+)
        if (!window.matchMedia('(min-width:1024px)').matches) return;

        const galleryHeight = this.getContentHeight(this.gallery);
        const infoPanelHeight = this.getContentHeight(this.infoPanel);
        const viewportHeight = window.innerHeight;
        
        // Account for sticky ATC bar (hidden on desktop but check anyway)
        const stickyATC = document.querySelector('sticky-add-to-cart');
        const stickyATCHeight = stickyATC && window.getComputedStyle(stickyATC).display !== 'none' ? stickyATC.offsetHeight : 0;

        const galleryIsShorter = galleryHeight < infoPanelHeight;
        const infoPanelIsShorter = infoPanelHeight < galleryHeight;

        if (Math.abs(galleryHeight - infoPanelHeight) < 100) return;

        if (infoPanelIsShorter) {
          const stickyTop = viewportHeight - infoPanelHeight - stickyATCHeight;
          
          this.infoPanel.style.position = 'sticky';
          this.infoPanel.style.top = `${stickyTop}px`;
          this.infoPanel.style.alignSelf = 'flex-start';
          
          const contentWrapper = this.infoPanel.querySelector('.pdp__content-wrapper');
          if (contentWrapper) {
            contentWrapper.style.position = 'relative';
            contentWrapper.style.top = 'auto';
            contentWrapper.style.bottom = 'auto';
          }
        } else if (galleryIsShorter) {
          const stickyTop = viewportHeight - galleryHeight - stickyATCHeight;
          
          this.gallery.style.position = 'sticky';
          this.gallery.style.top = `${stickyTop}px`;
          this.gallery.style.alignSelf = 'flex-start';
        }
      }

      resetStickyStyles() {
        if (this.gallery) {
          this.gallery.style.position = '';
          this.gallery.style.top = '';
          this.gallery.style.alignSelf = '';
        }
        
        if (this.infoPanel) {
          this.infoPanel.style.position = '';
          this.infoPanel.style.top = '';
          this.infoPanel.style.alignSelf = '';
          
          const contentWrapper = this.infoPanel.querySelector('.pdp__content-wrapper');
          if (contentWrapper) {
            contentWrapper.style.position = '';
            contentWrapper.style.top = '';
            contentWrapper.style.bottom = '';
          }
        }

        this.classList.remove('media-gallery--sticky');
      }

      changeImage(id) {
        if (!id) return;
        if (this.slideshow) {
          const slide = this.slideshow.querySelector(`[data-media-id="${id}"]`);
          this.slideshow.jumpToSlide(slide);
        } else if (this.thumbnailGallery) {
          this.thumbnailGallery.activateMedia(id.toString());
        }
        if (this.dataset.style === 'scroll' && window.matchMedia('(min-width:1024px)').matches) {
          const image = this.querySelector(`[data-media-id="${id}"]`);
          image.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  );
}